export default class SiteHeader {
	constructor() {
		this.headerHeight = 0;
		this.resizeEvent = null;
	}

	init() {
		this.resizeEvent = this.updateBodyPadding.bind(this);

		window.addEventListener('resize', this.resizeEvent, false);

		this.updateBodyPadding();
	}

	updateBodyPadding() {
		this.headerHeight = $('.header--standard .site-header').outerHeight() + 'px';
		$('body').css('padding-top', this.headerHeight);
	}

	destroy() {
		window.removeEventListener('resize', this.resizeEvent, false);
	}
}
